import { render, staticRenderFns } from "./registeredAccount.vue?vue&type=template&id=a0dc2954&scoped=true"
import script from "./registeredAccount.vue?vue&type=script&lang=js"
export * from "./registeredAccount.vue?vue&type=script&lang=js"
import style0 from "./registeredAccount.vue?vue&type=style&index=0&id=a0dc2954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dc2954",
  null
  
)

export default component.exports